import { Fragment } from 'react'
import styled, { css } from 'styled-components'

import { GlobalStyle } from './Styles'
import Icon from './Icon'

const DeleteIcon = styled(({ trash, button, position, label, ...props }) => {
  const name = trash ? 'icon-trash' : 'minus circle'

  if (label) {
    return (
      <a {...props}>
        {label}
        <Icon button name={name} />
        <GlobalStyle />
      </a>
    )
  }
  return (
    <Fragment>
      <Icon button name={name} {...props} />
      <GlobalStyle />
    </Fragment>
  )
})`
  ${({ theme, margin, position, label }) => css`
    &&& {
      color: ${theme.colors.abyss};
      margin: ${margin || '0 !important'};
      float: ${position || 'none'} !important;

      a& {
        display: flex;
        align-items: center;
      }

      .icon {
        margin-left: ${label ? '.25em' : 0};
      }

      :hover {
        color: ${theme.colors.red};
      }
    }
  `}
`

export default DeleteIcon
